import { render, staticRenderFns } from "./detailWbx.vue?vue&type=template&id=1f740098&scoped=true&"
import script from "./detailWbx.vue?vue&type=script&lang=js&"
export * from "./detailWbx.vue?vue&type=script&lang=js&"
import style0 from "./detailWbx.vue?vue&type=style&index=0&id=1f740098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f740098",
  null
  
)

export default component.exports